import { Box, Chip, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

const NetGAPAllocatedSection = ({ netGapAllocated }) => {
  const theme = useTheme();
  const { gapGreen } = theme.custom.colors;
  if (!netGapAllocated) return null;
  const { allocations, total } = netGapAllocated;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="labelD">Net GAP allocated</Typography>

      {allocations?.length > 0 ? (
        allocations.map((allocation, idx) => (
          <Box key={idx} sx={{ bgcolor: 'background.default', borderRadius: 2, p: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              {/* Left: name + date + type chip */}
              <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, flexShrink: 0 }}>
                <Box>
                  <Typography variant="labelM">{allocation.beneficiary_name}</Typography>
                  <Typography variant="p3" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                    {allocation.allocation_date}
                  </Typography>
                </Box>
                <Chip
                  label={allocation.allocation_type}
                  variant="outlined"
                  size="small"
                  sx={{ borderRadius: 1, height: 'auto', py: 0.25, ml: 0.25 }}
                />
              </Box>
              <Box sx={{ flexShrink: 0, textAlign: 'right' }}>
                <Typography variant="labelM">{allocation.allocation_amount}</Typography>
              </Box>
            </Box>
          </Box>
        ))
      ) : (
        <Box sx={{ bgcolor: 'background.default', borderRadius: 2, p: 2 }}>
          <Typography variant="p3" color="text.secondary" sx={{ textAlign: 'center', display: 'block' }}>
            No allocations for this period
          </Typography>
        </Box>
      )}

      {/* Total GAP Allocated */}
      <Box
        sx={{
          background: alpha(gapGreen, 0.08),
          borderRadius: 2,
          p: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="labelD">{total?.label || 'Total GAP Allocated'}</Typography>
        <Typography variant="labelD" sx={{ whiteSpace: 'nowrap' }}>{total?.value}</Typography>
      </Box>
    </Box>
  );
};

export default NetGAPAllocatedSection;
